export default "__VITE_PUBLIC_ASSET__3e4928ef__"